export default {
    separator: ", ",
    contactUs: {
        form_name: "contact_us",
    },
    subscribeNewsletter: {
        form_name: "subscribe_to_newsletter",
    },
    trackingType: {
        ga: "GoogleAnalytics",
        ga4: "GoogleAnalytics4",
        gtm: "GoogleTagManager",
    },
};
